import { FieldArray, useFormikContext } from 'formik'
import InputNumber from 'global/InputNumber/InputNumber'
import InputText from 'global/InputText/InputText'
import { BiTrash } from 'react-icons/bi'
import { FiPlus } from 'react-icons/fi'

function AddAnswerTable() {
  const { values, setFieldValue, touched, errors } = useFormikContext<any>()

  return (
    <div className='w-full'>
      <FieldArray name='questionContentList'>
        {({ remove, push }) => (
          <>
            <div className='flex justify-between items-center mb-4'>
              <h3 className="font-bold text-gray-700">لیست گزینه‌های پاسخ</h3>
              <button
                type="button"
                className='flex gap-1 items-center font-bold text-sm text-red-600 bg-red-50 px-4 py-2 rounded-lg border border-red-100 hover:bg-red-100 transition-all'
                onClick={() => push({ priority: values.questionContentList.length + 1, title: '' })}
              >
                <FiPlus size={20} /> افزودن گزینه جدید
              </button>
            </div>

            <div className="border border-gray-200 rounded-xl overflow-hidden shadow-sm">
              <table className='w-full text-center border-collapse'>
                <thead className="bg-[#fce8e8]">
                  <tr>
                    <th className="p-4 text-sm font-bold text-gray-700 w-24">عملیات</th>
                    <th className="p-4 text-sm font-bold text-gray-700 w-32">اولویت</th>
                    <th className="p-4 text-sm font-bold text-gray-700 text-right">عنوان پاسخ (گزینه)</th>
                  </tr>
                </thead>
                <tbody>
                  {values.questionContentList?.map((item: any, index: number) => (
                    <tr key={index} className="border-t border-gray-100 hover:bg-gray-50 transition-colors">
                      <td className="p-2">
                        <button 
                          type='button' 
                          className='text-gray-400 hover:text-red-600 p-2 rounded-full hover:bg-red-50' 
                          onClick={() => remove(index)}
                        >
                          <BiTrash size={20} />
                        </button>
                      </td>
                      <td className="p-2">
                         <InputNumber
                          wrapperClassName={'w-24 mx-auto'}
                          handleChange={(n, v) => setFieldValue(`questionContentList.${index}.priority`, v)}
                          name={`questionContentList.${index}.priority`}
                          values={values.questionContentList[index].priority}
                          hiddenError
                        />
                      </td>
                      <td className="p-2">
                        <InputText
                          wrapperClassName={'w-full'}
                          handleChange={(e) => setFieldValue(`questionContentList.${index}.title`, e.target.value)}
                          name={`questionContentList.${index}.title`}
                          values={values.questionContentList[index].title}
                          error={touched.questionContentList?.[index]?.title && (errors.questionContentList as any)?.[index]?.title}
                          placeholder="مثلاً: عالی"
                          hiddenError
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </FieldArray>
    </div>
  )
}

export default AddAnswerTable
